import { Button, Box, Text } from '@vibe/core';
import { AppModal, AppModalContent } from '@gorilla/ui/src/components/AppModal';
import { Heading } from '@vibe/core';

type ResetSettingsModalProps = {
  show: boolean;
  onClose: (reset: boolean) => void;
};

export function ResetSettingsModal({ show, onClose }: ResetSettingsModalProps) {
  return (
    <AppModal
      contentSpacing={false}
      alertDialog={true}
      data-testid="resetModal"
      width={300}
      show={show}
      onClose={() => {
        onClose(false);
      }}
    >
      <AppModalContent>
        <Box marginBottom="large">
          <Heading type="h3" weight="bold" align="start" style={{ marginBottom: '10px' }}>
            Reset settings
          </Heading>
          <Text type="text2" align="start" color="secondary" element="p">
            If you reset the settings for this widget, all configurations are adjusted to their default values. This will not directly
            reflect on the published widget until you republish it.
          </Text>
        </Box>

        <Box marginBottom="medium">
          <Button
            size="medium"
            kind="primary"
            color="negative"
            style={{
              width: '100%',
            }}
            onClick={() => {
              onClose(true);
            }}
          >
            Reset settings
          </Button>
        </Box>
      </AppModalContent>
    </AppModal>
  );
}
